<script setup>
import { inject, provide, ref } from 'vue';
import ImudeiBrokerDashboardReference from './ImudeiBrokerDashboardReference.vue';

defineProps({
  records: { type: Array, default: () => [] },
  total: { type: Number, default: 0 },
});

const emit = defineEmits(['navigate']);
const emptyRuntime = {
  actions: { brokers: {} },
  data: ref({}),
  error: ref(''),
  loading: ref(false),
  refresh: async () => null,
  selectedId: ref(''),
};
const realData = inject('imudeiRealData', emptyRuntime);

provide('imudeiRealData', realData);
</script>

<template>
  <ImudeiBrokerDashboardReference
    :records="records"
    :total="total"
    @navigate="emit('navigate', $event)"
  />
</template>
